import type { ComponentChildren } from "preact";
import { t } from "../i18n";
import { hrefFor, parseRoute } from "../app/router";
import { AccountBar } from "./AccountBar";
import { LanguageSwitcher } from "./LanguageSwitcher";

const NAV = [
  { name: "landing" as const, href: "/", label: "nav.home" },
  { name: "radar" as const, href: "/radar", label: "nav.radar" },
  { name: "skills-match" as const, href: "/skills-match", label: "nav.match" },
  { name: "methodology" as const, href: "/methodology", label: "nav.methodology" },
];

export function AppShell({ children }: { children: ComponentChildren }) {
  const current = parseRoute().name;
  return (
    <div class="obs-shell">
      <a class="obs-skip" href="#obs-main">
        {t("nav.skip")}
      </a>
      <nav class="obs-local-nav" aria-label={t("brand.observatory")}>
        <div class="obs-local-nav-inner">
          {NAV.map((item) => (
            <a
              key={item.name}
              href={hrefFor(item.href)}
              aria-current={current === item.name ? "page" : undefined}
            >
              {t(item.label)}
            </a>
          ))}
          <LanguageSwitcher />
          <AccountBar />
        </div>
      </nav>
      <div id="obs-main">{children}</div>
      <p class="obs-footer-note">{t("footer.notice")}</p>
    </div>
  );
}
